import React from 'react'

import { Portlet, Tabs } from '_zari/core'

import * as Modals from './modals'

import * as InnerTabs from './tabs'

const portletBreadcrumbs = [{ name: 'Emisor Documentos' }]

const EmisorDocumentosMainPage = () => {
  const [modalDescargaMasiva, setModalDescargaMasiva] = React.useState(false)
  const [modalDescargarInforme, setModalDescargarInforme] = React.useState(false)

  const clickDescargaMasiva = React.useCallback(() => {
    setModalDescargaMasiva(true)
  }, [])

  const clickDescargarInforme = React.useCallback(() => {
    setModalDescargarInforme(true)
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Emisor Documentos'
          breadcrumbs={portletBreadcrumbs}
          buttons={[
            { name: 'Descarga Masiva', onClick: clickDescargaMasiva },
            { name: 'Descarga Informe', onClick: clickDescargarInforme }
          ]}
        />
        <Portlet.Body>
          <Tabs defaultActiveKey='1' id='emisor-documentos-tabs'>
            <Tabs.Tab eventKey='1' title='Comprobantes (FACTURAS)'>
              <InnerTabs.TabComprobantesElectronicos />
            </Tabs.Tab>
            <Tabs.Tab eventKey='2' title='Comprobantes (GUIAS)'>
              <InnerTabs.TabGuiasElectronicas />
            </Tabs.Tab>
            <Tabs.Tab eventKey='3' title='Resumen Diario (BOLETAS)'>
              <InnerTabs.TabResumenDiario />
            </Tabs.Tab>
            <Tabs.Tab eventKey='4' title='Resumen Diario (NOTAS)'>
              <InnerTabs.TabResumenDiarioNotas />
            </Tabs.Tab>
            <Tabs.Tab eventKey='5' title='Resumen Diario (BAJAS)'>
              <InnerTabs.TabResumenDiarioBajas />
            </Tabs.Tab>
            <Tabs.Tab eventKey='6' title='Consulta Ticket'>
              <InnerTabs.TabConsultaTicket />
            </Tabs.Tab>
          </Tabs>
        </Portlet.Body>
      </Portlet>
      {modalDescargaMasiva && <Modals.DescargaMasivaModal show={modalDescargaMasiva} handleClose={() => setModalDescargaMasiva(false)} />}
      {modalDescargarInforme && <Modals.DescargarInformeModal show={modalDescargarInforme} handleClose={() => setModalDescargarInforme(false)} />}
    </>
  )
}

export default EmisorDocumentosMainPage
